module.exports = __webpack_public_path__ + "assets/f64834a4f47bf10cd8088bcf1f8f329f.png";